import { render } from "./_ModalWrapper.vue?vue&type=template&id=e64930a6&scoped=true"
import script from "./_ModalWrapper.vue?vue&type=script&lang=js"
export * from "./_ModalWrapper.vue?vue&type=script&lang=js"

import "./_ModalWrapper.vue?vue&type=style&index=0&id=e64930a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64930a6"],['__file',"src/scripts/sections/modals/_ModalWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e64930a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e64930a6', __exports__)) {
    api.reload('e64930a6', __exports__)
  }
  
  module.hot.accept("./_ModalWrapper.vue?vue&type=template&id=e64930a6&scoped=true", () => {
    api.rerender('e64930a6', render)
  })

}


export default __exports__